import { getFormattedDateString } from '../../header/utils'
import { ActionTypes } from '../constants/constants'
import AppDispatcher from '../dispatcher/appDispatcher'
import { BubbleNode, BubblesLoadParam, Range } from '../types'
import Store from './store'

var _isLoading: boolean
var _hasError: boolean
var _errorCode: any

var _params: BubblesLoadParam

var _bubbles: BubbleNode[] = []
var _bubblesInRange: BubbleNode[] = []
var _rangeX: Range
var _rangeY: Range

var _dataUpdateTimeString: string
var _modal = { shown: false, failed: false, completed: false, imgUrl: '', shareUrl: '' }
class BubbleStore extends Store {
  isLoading() {
    return _isLoading
  }

  hasError() {
    return _hasError
  }

  getErrorCode() {
    return _errorCode
  }

  getParams() {
    return _params
  }

  getBubbles() {
    return _bubbles
  }

  getBubblesInRange() {
    return _bubblesInRange
  }

  getRange(type: string) {
    if (type === 'x') {
      return _rangeX
    } else {
      return _rangeY
    }
  }

  getRanges() {
    return {
      x: _rangeX,
      y: _rangeY,
    }
  }

  getModal() {
    return _modal
  }

  getDataUpdateTimeString() {
    return _dataUpdateTimeString
  }
}
var bubbleStore = new BubbleStore()

var parseRange = function (range: string) {
  try {
    var parts = range.split('|')
    return {
      min: parseFloat(parts[0]),
      max: parseFloat(parts[1]),
    }
  } catch {}
  return false
}

var changeRange = function (type: string, range: Range) {
  if (type === 'x') {
    _rangeX = range
  } else {
    _rangeY = range
  }

  _bubblesInRange = _bubbles.filter(function (d) {
    var val = true
    if (_rangeX) {
      val = val && d.x >= _rangeX.min && d.x <= _rangeX.max
    }
    if (_rangeY) {
      val = val && d.y >= _rangeY.min && d.y <= _rangeY.max
    }
    return val
  })

  if (_rangeX) {
    _params.rangeX = _rangeX.min + '|' + _rangeX.max
  }
  if (_rangeY) {
    _params.rangeY = _rangeY.min + '|' + _rangeY.max
  }
}

// @ts-ignore
bubbleStore.dispatchToken = AppDispatcher.register(function (payload: any) {
  var action = payload.action

  switch (action.type) {
    case ActionTypes.LOAD_DATA_STARTED:
      _params = action.params
      _isLoading = true
      _hasError = false
      bubbleStore.emitChange()
      break

    case ActionTypes.LOAD_DATA_COMPLETED:
      _isLoading = false
      _dataUpdateTimeString = getFormattedDateString()

      _bubbles = action.data.map((node: any) => {
        const parsedX = parseFloat(node.x)
        const parsedY = parseFloat(node.y)
        const parsedSize = parseFloat(node.size)
        const parsedColor = parseFloat(node.color)

        return {
          ...node,
          x: Number.isFinite(parsedX) ? parsedX : node.x,
          y: Number.isFinite(parsedY) ? parsedY : node.y,
          size: Number.isFinite(parsedSize) ? parsedSize : node.size,
          color: Number.isFinite(parsedColor) ? parsedColor : node.color,
        }
      })
      _bubbles.sort(function (a, b) {
        return b.size - a.size
      })

      _bubblesInRange = _bubbles

      if (_params.rangeX && parseRange(_params.rangeX)) {
        // @ts-ignore
        changeRange('x', parseRange(_params.rangeX))
      }

      if (_params.rangeY && parseRange(_params.rangeY)) {
        // @ts-ignore
        changeRange('y', parseRange(_params.rangeY))
      }

      bubbleStore.emitChange()
      break

    case ActionTypes.LOAD_DATA_FAILED:
      _isLoading = false
      _hasError = true
      _errorCode = action.errorStatus
      bubbleStore.emitChange()
      break

    case ActionTypes.CHANGE_RANGE:
      changeRange(action.rangeType, action.range)
      bubbleStore.emitChange()
      break

    case ActionTypes.PUBLISH_BUBBLES_STARTED:
      _modal.shown = true
      _modal.failed = false
      _modal.completed = false
      bubbleStore.emitChange()
      break

    case ActionTypes.PUBLISH_BUBBLES_COMPLETED:
      _modal.failed = false
      _modal.completed = true
      _modal.imgUrl = action.data.imgUrl
      _modal.shareUrl = action.data.shareUrl
      bubbleStore.emitChange()
      break

    case ActionTypes.PUBLISH_BUBBLES_FAILED:
      _modal.failed = true
      bubbleStore.emitChange()
      break

    case ActionTypes.PUBLISH_BUBBLES_CLOSE:
      _modal.shown = false
      bubbleStore.emitChange()
      break
  }
})

export default bubbleStore
